import { Component, OnDestroy, OnInit } from '@angular/core';
import { SubHeaderService } from '../../../../shared/store/subheader/subheader.service';
import { ContractService } from '../../../../shared/store/contract/contract.service';
import { filter, Observable } from 'rxjs';
import { ContractModel } from '../../../../shared/store/contract/types';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-contract-custom-subheader',
  standalone: false,
  templateUrl: './contract-custom-subheader.component.html',
  styleUrl: './contract-custom-subheader.component.scss',
})
export class ContractCustomSubheaderComponent implements OnInit, OnDestroy {
  isContractReadOnly$: Observable<boolean>;
  contractBase$: Observable<ContractModel>;

  constructor(
    private readonly subHeaderService: SubHeaderService,
    private readonly contractService: ContractService,
  ) {
    this.contractBase$ = this.contractService.getByUniqueId.value$;
    this.isContractReadOnly$ =
      this.contractService.getIfDataReadOnlyFromContractId.value$;
  }

  ngOnInit(): void {
    this.contractBase$
      .pipe(
        filter((x) => x !== null && x !== undefined),
        untilDestroyed(this),
      )
      .subscribe((contractModel) => {
        this.contractService.getIfDataReadOnlyFromContractId.call(
          contractModel.id,
        );
      });
  }

  triggerAction(actionName) {
    this.subHeaderService.setTriggerAction(actionName);
  }

  ngOnDestroy(): void {
    this.contractService.getIfDataReadOnlyFromContractId.reset();
  }
}
